import styled from "styled-components";
import { theme } from "../../../../../theme";

export const Wrapper = styled('div')`

` 

